export default __webpack_public_path__ + "static/media/back.2d863411.svg";